module.exports = __webpack_public_path__ + "static/img/annualMajorEvent1.b0a765b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/annualMajorEvent1.png
// module id = acPa
// module chunks = 1